module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-mv.7018d2c8.png";